<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <form @submit.prevent="cadastrarCotaDeSubsidio" class="cadastro-de-empreendimento formulario">
        <h2 class="titulo titulo_grande">Preencha todos os campos obrigatórios abaixo para cadastrar uma cota de subsídio
        </h2>
        <h3 class="subtitle is-5">
          <i class="fal fa-chart-network"></i> Dados do município
        </h3>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Projeto</label>
            <select v-model="cotaDeSubsidio.ProjetoId" required @change="informarSobreProjetoQueNaoPodeTerCotas">
              <option v-for="projeto in projetos" :value="projeto.Id"
                :selected="projeto.Id === cotaDeSubsidio.ProjetoId ? 'selected' : ''">
                {{ projeto.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Cidade</label>
            <select v-model="cotaDeSubsidio.CidadeId" required>
              <option v-for="cidade in cidades" :value="cidade.Id"
                :selected="cidade.Id === cotaDeSubsidio.CidadeId ? 'selected' : ''">
                {{ cidade.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_1">
            <label class="label" for="totalDeCotas">Total de cotas disponibilizadas</label>
            <input name="totalDeCotas" type="number" id="totalDeCotas" class="input uppercase"
              placeholder="Ex: 100" v-model="cotaDeSubsidio.Quantidade" required />
          </div>
        </div>
        <hr>
        <div v-if="deveExibirBotoes" class="grade__linha">
          <router-link :to="{ name: 'ListaDeCotas' }"
            class="botao botao_cinza botao_medio u-margem-direita-pequena"
            :class="{ 'is-disabled': loading.visivel }">Cancelar</router-link>
          <button type="submit" class="botao botao_cor-terciaria botao_medio"
            :class="{ 'is-loading': loading.visivel }">Salvar cota</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AwesomeMask from 'awesome-mask';
import Loading from '../shared/Loading';
import Alerta from '../shared/Alerta';

export default {
  name: 'cadastrar-cota',
  directives: { mask: AwesomeMask },
  components: { Loading, Alerta },
  data() {
    return {
      cotaDeSubsidio: {
        CidadeId: null,
        ProjetoId: null,
        Quantidade: null
      },
      cidades: this.cidades || [],
      projetos: this.projetos || [],
      deveExibirBotoes: true,
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      mensagemParaProjetoSemCotas: "Não é possível cadastrar cotas para o projeto selecionado",
      tipoDeAlerta: null,
    };
  },
  created() {
    this.$api.get('/Cidade').then((response) => {
      this.cidades = [{ Id: null, Nome: 'Selecione uma cidade' }];
      this.cidades = this.cidades.concat(response.data);
      return response;
    }).catch((error) => {
      this.tratarErro(error);
    });

    this.$api.get('/Projeto/ObterVigentes').then((response) => {
        this.projetos = [{ Id: null, Nome: 'Selecione um projeto' }];
        this.projetos = this.projetos.concat(response.data);
        return response;
    }).catch((error) => {
      this.tratarErro(error);
    });
  },
  methods: {
    projetoPodeCadastrarCota(){
      if(this.cotaDeSubsidio.ProjetoId) {
        const projeto = this.projetos.filter(p=> p.Id == this.cotaDeSubsidio.ProjetoId)[0]
        return projeto.EhBonusMoradia
      }
    },
    cadastrarCotaDeSubsidio() {
      this.exibirCarregamento('Só um momento, estamos cadastrando uma nova cota de subsídio...');
      this.$api.post('/Cotas', this.cotaDeSubsidio).then(() => {
        this.$router.push({ name: 'ListaDeCotas' });
      }).catch((error) => {
        this.tratarErro(error);
      });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    informarSobreProjetoQueNaoPodeTerCotas(){
      this.tipoDeAlerta = 'atencao';

      if(!this.projetoPodeCadastrarCota()){
        this.mensagemDeAlerta = "Não é possível cadastrar cotas para o projeto selecionado";
        this.deveExibirBotoes = false;
      }
      else{
        this.mensagemDeAlerta = null;
        this.deveExibirBotoes = true;
      }
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = 'erro';
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta = mensagensDeErro || 'Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte';
    }
  },
};
</script>



// WEBPACK FOOTER //
// CadastrarCota.vue?407cf518